<div *ngIf="visible" class="msg" [ngClass]="color">
    <span>{{msg}}</span>
</div>
